import { Chip, SxProps, Theme } from '@mui/material';

interface RndChipProps {
  sx?: SxProps<Theme>;
}

function RndChip({ sx }: RndChipProps) {
  return <Chip label="R&D" color="info" size="small" sx={sx} />;
}

export default RndChip;
